module.exports = require("./tip.jsx");
